<ng-container *ngIf="isMobile; else desktopAssistanceInfo">
  <app-swipe-up
    [height]="90"
    [showHeader]="true"
    [showFooter]="true"
    [showSwipeUp]="showAssistanceInfo"
    [title]="config.ASSISTANCE.TITLE"
    [subTitle]="subTitle"
    (toggleShowSwipeUp)="close()">
    <ng-container content>
        <ng-container *ngTemplateOutlet="contentInfo"></ng-container>
    </ng-container>
    <ng-container footer>
      <ng-container *ngTemplateOutlet="contentInfoFooter"></ng-container>
  </ng-container>
  </app-swipe-up>

  <ng-container *ngIf="showDetailInfo">
    <ng-container *ngTemplateOutlet="details"></ng-container>
  </ng-container>
</ng-container>

<ng-template #desktopAssistanceInfo>
  <ng-container *ngIf="showAssistanceInfo">
    <app-side-bar
      [manipulateDOM]="!isCrossSelling"
      [showHeader]="true"
      [title]="config.ASSISTANCE.TITLE"
      [subTitle]="subTitle"
      (toggleModal)="close()">
      <ng-container content>
        <ng-container *ngIf="showDetailInfo; else contentInfo">
          <ng-container *ngTemplateOutlet="details"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!showDetailInfo" footer>
        <ng-container *ngTemplateOutlet="contentInfoFooter"></ng-container>
      </ng-container>
    </app-side-bar>
  </ng-container>
</ng-template>

<ng-template #contentInfo>
  <div class="travelAssistanceContent__body">
    <ng-content select="[assistanceBanner]"></ng-content>
  </div>
</ng-template>

<ng-template #details>
  <div class="terms-and-details {{animation}} smooth-animated">
    <app-chubb-details-and-terms
      [isMobile]="isMobile"
      [assistanceValues]="assistanceValues"
      [isCrossSelling]="isCrossSelling"
      (closeDetail)="closeDetails()">
    </app-chubb-details-and-terms>
  </div>
</ng-template>

<ng-template #contentInfoFooter>
  <ng-container *ngIf="!!isCrossSelling; else forcedSelectionAction">
    <ng-container *ngTemplateOutlet="crossSellingAction"></ng-container>
  </ng-container>
</ng-template>

<ng-template #forcedSelectionAction>
  <ng-container *ngIf="!isBR; else forcedSelectionBrazil">
    <span class="actionButtonContent__terms" [class.link]="isMX" (click)="openAssistanceDocument()">
      {{config.ASSISTANCE.CHECKBOX_MESSAGE_TERMS}}
    </span>
  </ng-container>
  <ng-template #forcedSelectionBrazil>
    <div class="actionButtonContent">
      <div class="actionButtonContent__terms">
        <span>{{config.ASSISTANCE.CHECKBOX_MESSAGE_TERMS}}</span>
      </div>
      <div class="actionButtonContent__checkbox" (click)="toggleAcceptAssistance()">
      <input type="checkbox" [(ngModel)]="isChecked">
        <label></label>
      </div>
    </div>
  </ng-template>
  <div class="actionButtonContent__buttons">
    <app-btn-go-to-pay
      [isMobile]="isMobile"
      [isFixed]="false"
      [disabled]="isDisabledForceSelection"
      [isLoadingBooking]="isLoadingForcedSelectionYes"
      [applyConversion]="applyConversion"
      [conversionRate]="conversionRate"
      [finalPrice]="priceWithAssistance"
      [currencyCode]="currencyCode"
      [label]="config.ASSISTANCE.FORCED_YES"
      (goToPay)="payButtonAction(true)">
    </app-btn-go-to-pay>
    <app-btn-go-to-pay
      [isMobile]="isMobile"
      [isFixed]="false"
      [disabled]="isDisabledForceSelectionNo"
      [isLoadingBooking]="isLoadingForcedSelectionNo"
      [applyConversion]="applyConversion"
      [conversionRate]="conversionRate"
      [finalPrice]="basePrice"
      [currencyCode]="currencyCode"
      [label]="config.ASSISTANCE.FORCED_NO"
      [buttonType]="declineButtonType"
      (goToPay)="payButtonAction(false)">
    </app-btn-go-to-pay>
  </div>
</ng-template>

<ng-template #crossSellingAction>
  <span class="actionButtonContent__terms">
    {{config.ASSISTANCE.CHECKBOX_MESSAGE_TERMS}}
  </span>
  <div class="actionButtonContent__buttons">
    <app-ds-button
      [isLoading]="isLoading"
      [labels]="{ ButtonLabel: config.ASSISTANCE.YES_ACTION_BOOK }"
      (clickEvent)="crossSellingButtonAction()">
    </app-ds-button>
    <app-ds-button
      [type]="declineButtonType"
      [labels]="{ ButtonLabel: config.ASSISTANCE.NO_ACTION_BOOK }"
      (clickEvent)="close()">
    </app-ds-button>
  </div>
</ng-template>

<app-swipe-up *ngIf="showPdf" [height]="85" [showSwipeUp]="showPdf" (toggleShowSwipeUp)="toggleOpenPdfView()">
  <ng-container content>
    <div class="modal-pdf">
      <div class="button-close-modal">
        <i aria-hidden="true" (click)="toggleOpenPdfView()" class="icon-close"></i>
      </div>
      <div class="content-pdf" *ngIf="showPdf">
        <app-pdf-viewer [srcPdf]="srcPdf"></app-pdf-viewer>
      </div>
    </div>
  </ng-container>
</app-swipe-up>